export const PERSISTENT_TOAST_DURATION = Number.POSITIVE_INFINITY
